/* REACT IMPORTS */
import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

/* REACT TOASTIFY  */
import { ToastContainer } from "react-toastify";

/* IMPORT REACT-TOASTIFY CSS  */
import "react-toastify/dist/ReactToastify.css";

/* STYLES */
import "styles/globals.css";

/* ROUTES */
import RegistrationForm from "pages";

/* SCROLL TO TOP */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const AppRoutes = () => {
  return (
    <div className="app">
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<RegistrationForm />} />
        </Routes>
        <ToastContainer
          position="top-right"
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </Router>
    </div>
  );
};

export default AppRoutes;
